import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { DeficiencyComments } from './deficiencyComments.types';

export const deficiencyCommentsPullQueryBuilder = (document: DeficiencyComments) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query mobileDeficiencyWiseAuditComments($lastRequested: DateTime!) {
      mobileDeficiencyWiseAuditComments(lastRequested: $lastRequested) {
        pkUuid
        pkDeficiencyWiseAuditComments
        fkAssetInspectionComponentFailure
        inspectorId
        inspectorRoleId
        comment
        dateCreated
        dateModified
        createdBy
        isActive
        attentionFlag
        inspectorName
        clerkName
        componentVersionInspectionId
        componentVersionId
      }
    }
  `);

  return {
    query,
    variables: {
      lastRequested: doc?.dateModified ? doc?.dateModified : doc?.dateCreated,
    },
  };
};

export const deficiencyVersionCommentsPullQueryBuilder = (document: DeficiencyComments) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query mobileDeficiencyVersionAuditComments($lastRequested: DateTime!) {
      mobileDeficiencyVersionAuditComments(lastRequested: $lastRequested) {
        pkUuid
        pkDeficiencyWiseAuditComments
        fkAssetInspectionComponentFailure
        inspectorId
        inspectorRoleId
        comment
        dateCreated
        dateModified
        createdBy
        isActive
        attentionFlag
        inspectorName
        componentVersionInspectionId
        componentVersionId
        isVersionComment
      }
    }
  `);

  return {
    query,
    variables: {
      lastRequested: doc?.dateModified ? doc?.dateModified : doc?.dateCreated,
    },
  };
};
